import { Platform } from 'react-native';
import * as Haptics from 'expo-haptics';

const IS_WEB = Platform.OS === 'web';

/** A crisp tick when a draggable item is lifted. */
export function hapticPickUp() {
  if (IS_WEB) return;
  Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Rigid).catch(() => {});
}

/** A softer tick when a dragged item is released/settled. */
export function hapticSetDown() {
  if (IS_WEB) return;
  Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Soft).catch(() => {});
}

/** A light tick each time a dragged item crosses into a new slot. */
export function hapticReorderTick() {
  if (IS_WEB) return;
  Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light).catch(() => {});
}

/** A warning buzz when a tap lands on a field a collaborator has claimed. */
export function hapticClaimBlocked() {
  if (IS_WEB) return;
  Haptics.notificationAsync(Haptics.NotificationFeedbackType.Warning).catch(() => {});
}
